var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPadlock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 56,
    viewBox: "0 0 52 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2992_17359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.004 19.9999C23.6183 19.9999 21.336 21.5279 21.336 24.7969L21.336 26.5747C20.4453 26.751 20 27.3461 20 28.4186L20 34.0899C20 35.3975 20.6441 35.9999 21.9404 35.9999L30.0596 35.9999C31.3559 35.9999 32 35.3975 32 34.0899L32 28.4186C32 27.3461 31.5626 26.751 30.664 26.5747L30.664 24.7969C30.664 21.5279 28.3817 19.9999 26.004 19.9999ZM23.4199 24.6868C23.4199 22.7841 24.6128 21.8585 26.0044 21.8585C27.3961 21.8585 28.581 22.7841 28.581 24.6868L28.581 26.5233L23.4199 26.5234L23.4199 24.6868ZM29.4478 28.257C29.7738 28.257 29.9249 28.3965 29.9249 28.7418L29.9249 33.7666C29.9249 34.1192 29.7738 34.2588 29.4478 34.2588L22.5611 34.2588C22.243 34.2588 22.084 34.1192 22.084 33.7666L22.084 28.7418C22.084 28.3965 22.243 28.257 22.5611 28.257L29.4478 28.257Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2992_17359",
    x: 0,
    y: -0.00012207,
    width: 52,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2992_17359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2992_17359",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPadlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Padlock.145bd13113acf36200736df53b2db643.svg";